const ar = {
  // التنقل
  nav_intro: 'عن الشركة',
  nav_business: 'أعمالنا',
  nav_events: 'الفعاليات الصناعية',
  nav_team: 'فريقنا',
  nav_achievements: 'الإنجازات',
  nav_contact: 'اتصل بنا',
  
  // القسم الرئيسي
  hero_main_title: 'تجارة احترافية',
  hero_main_subtitle: 'لهواتف Apple',
  hero_company_intro: 'تأسست شركة Hong Kong BOJM Trading Co., Ltd. في عام ',
  hero_company_year: '2011',
  hero_company_desc: '، وهي متخصصة في التجارة العالمية لهواتف Apple الذكية.',
  hero_business_desc: 'نحن متخصصون في بيع ',
  hero_product_1: 'هواتف Apple المجددة',
  hero_product_2: 'هواتف Apple الجديدة',
  hero_product_3: 'هواتف Apple المستعملة',
  hero_business_coverage: '، ويغطي عملنا أوروبا ودبي وأمريكا اللاتينية وجنوب شرق آسيا والأسواق العالمية الأخرى.',
  hero_cta_contact: 'اتصل بنا',
  hero_cta_learn: 'اعرف المزيد',
  
  // عن الشركة
  intro_title: 'عن',
  intro_title_highlight: 'BOJM Trading',
  intro_company_name: 'Hong Kong BOJM Trading Co., Ltd.',
  intro_company_name_en: '香港博鑫貿易有限公司',
  intro_founded: 'تأسست في عام ',
  intro_founded_year: '2011',
  intro_desc_1: '، نحن شركة محترفة متخصصة في التجارة العالمية لهواتف Apple الذكية. بعد أكثر من عقد من التطور، أصبحنا شريكًا موثوقًا به في الصناعة.',
  intro_desc_2: 'نحن متخصصون في بيع ',
  intro_desc_3: ' الهواتف الذكية. بفضل الخبرة الصناعية الواسعة وشبكة سلسلة التوريد الواسعة، نقدم منتجات وخدمات عالية الجودة للعملاء في جميع أنحاء العالم.',
  intro_stat_year: '2011',
  intro_stat_year_label: 'سنة التأسيس',
  intro_stat_coverage: '4+',
  intro_stat_coverage_label: 'مناطق عالمية',
  intro_experience: '13+',
  intro_experience_label: 'سنوات من الخبرة',
  
  // الأعمال
  business_title: 'أعمالنا',
  business_title_highlight: '',
  business_subtitle: 'متخصصون في التجارة العالمية لهواتف Apple الذكية، نقدم خدمات مبيعات احترافية لـ ',
  business_subtitle_bold_1: 'هواتف Apple الجديدة',
  business_subtitle_bold_2: 'هواتف Apple المجددة',
  business_subtitle_bold_3: 'هواتف Apple المستعملة',
  business_subtitle_end: '',
  
  business_new_title: 'هواتف Apple الجديدة',
  business_new_desc: 'أحدث منتجات سلسلة iPhone، جديدة ومختومة، ضمان الأصالة، مع خدمة الضمان العالمي.',
  business_new_feature_1: 'جديدة ومختومة',
  business_new_feature_2: 'أصلية',
  business_new_feature_3: 'ضمان عالمي',
  
  business_resource_title: 'هواتف Apple المجددة',
  business_resource_desc: 'مصادر هواتف مجددة عالية الجودة، تم فحصها بدقة، سعر تنافسي، مناسبة للشراء بالجملة والتوزيع عبر القنوات.',
  business_resource_feature_1: 'فحص دقيق',
  business_resource_feature_2: 'خصومات الجملة',
  business_resource_feature_3: 'ميزة القنوات',
  
  business_used_title: 'هواتف Apple المستعملة',
  business_used_desc: 'هواتف iPhone مستعملة عالية الجودة مختارة، تم اختبارها وتجديدها بشكل احترافي، جودة موثوقة، سعر معقول، أفضل خيار من حيث القيمة.',
  business_used_feature_1: 'اختبار احترافي',
  business_used_feature_2: 'ضمان الجودة',
  business_used_feature_3: 'سعر معقول',
  
  business_coverage_title: 'التغطية التجارية العالمية',
  business_coverage_subtitle: 'تمتد منتجاتنا وخدماتنا عبر أربعة أسواق عالمية رئيسية',
  business_region_europe: 'أوروبا',
  business_region_europe_en: '歐洲',
  business_region_dubai: 'دبي',
  business_region_dubai_en: '迪拜',
  business_region_latam: 'أمريكا اللاتينية',
  business_region_latam_en: '拉美',
  business_region_sea: 'جنوب شرق آسيا',
  business_region_sea_en: '東南亞',
  
  // الفعاليات
  events_title: 'الفعاليات',
  events_title_highlight: 'الصناعية',
  events_subtitle: 'نشارك بنشاط في ',
  events_subtitle_bold: 'جمعية هونغ كونغ الدولية للتجارة الإلكترونية للاتصالات',
  events_subtitle_end: ' والمنظمات الصناعية الأخرى، مع الحفاظ على علاقات وثيقة مع الشركاء العالميين',
  
  events_event1_title: 'القمة السنوية لـ HKICEC',
  events_event1_date: '13 نوفمبر 2025',
  events_event1_desc: 'أقيم حفل التنصيب الافتتاحي والعشاء الاحتفالي بنجاح كبير، حضره أكثر من 200 شركة عضو. هونغ كونغ - تم تأسيس جمعية هونغ كونغ الدولية للتجارة الإلكترونية للاتصالات (HKICEC)، التي بادر بها قادة الصناعة بشكل مشترك، رسميًا في 13 نوفمبر 2025. أقيم حفل التنصيب الافتتاحي والعشاء الاحتفالي في مركز هونغ كونغ للمؤتمرات والمعارض (الجناح الجديد)، مما يمثل معلمًا جديدًا لصناعة التجارة الإلكترونية للاتصالات في هونغ كونغ.',
  
  events_event2_title: 'أنشطة التبادل لـ HKICEC',
  events_event2_date: '13 نوفمبر 2025',
  events_event2_desc: 'اجتمعممثلو الشركات الأعضاء لمناقشة اتجاهات تطوير الصناعة وفرص التعاون. كان الحدث حماسيًا، حيث أجرى ممثلو الشركات المختلفة تبادلات متعمقة حول أحدث التطورات وفرص السوق والاتجاهات المستقبلية في مجال التجارة الإلكترونية للاتصالات.',
  
  events_tag_1: 'HKICEC',
  events_tag_2: 'قمة صناعية',
  events_tag_3: 'تبادل دولي',
  events_member_badge: 'وحدة عضو',
  
  // الفريق
  team_title: 'فريقنا',
  team_title_highlight: 'الأساسي',
  team_subtitle: 'فريق إداري ذو خبرة يقود التطوير والابتكار المستمر',
  
  team_ceo_name: 'تشانغ قوه سونغ',
  team_ceo_position: 'الرئيس التنفيذي',
  team_ceo_desc: 'يتمتع بخبرة تزيد عن 20 عامًا في صناعة الهواتف المحمولة، عمل بشكل وثيق مع علامات تجارية مشهورة مثل Transsion و Xiaomi، ويمتلك خبرة واسعة وموارد صناعية واسعة في تجارة الهواتف المحمولة.',
  
  team_sales_name: 'لي تشنغ روي',
  team_sales_position: 'مدير المبيعات والعمليات',
  team_sales_desc: 'مسؤول عن صياغة استراتيجية المبيعات للشركة وإدارة العمليات، يقود الفريق لتوسيع الأسواق العالمية، مما يضمن العمليات التجارية الفعالة والنمو المستمر.',
  
  // الإنجازات
  achievements_title: 'إنجازاتنا',
  achievements_title_highlight: '',
  achievements_subtitle: 'أداء نمو مستمر، يشهد على قوتنا المهنية وثقة السوق',
  
  achievements_last_year: '2 مليار',
  achievements_last_year_label: 'مبيعات العام الماضي',
  achievements_last_year_period: 'أداء المبيعات السنوي 2023',
  
  achievements_this_year: '5 مليار',
  achievements_this_year_label: 'مبيعات هذا العام',
  achievements_this_year_period: 'أداء المبيعات السنوي 2024',
  
  achievements_growth_title: 'معدل النمو السنوي',
  achievements_growth_desc_1: 'من 2 مليار في 2023 إلى 5 مليار في 2024، حققنا نموًا مذهلاً بنسبة ',
  achievements_growth_rate: '150%',
  achievements_growth_desc_2: '، مما يدل بشكل كامل على قدرتنا التنافسية في السوق وثقة العملاء.',
  achievements_year_2023: '2023',
  achievements_year_2024: '2024',
  achievements_growth_indicator: '+150%',
  
  achievements_stat_experience: '13+',
  achievements_stat_experience_label: 'سنوات من الخبرة',
  achievements_stat_markets: '4+',
  achievements_stat_markets_label: 'مناطق السوق العالمية',
  achievements_stat_team: 'محترف',
  achievements_stat_team_label: 'فريق الإدارة الأساسي',
  achievements_stat_quality: 'جودة',
  achievements_stat_quality_label: 'المنتجات والخدمات',
  
  // الاتصال
  contact_title: 'اتصل',
  contact_title_highlight: 'بنا',
  contact_intro: 'مرحبًا بك للاتصال بنا، سنقدم لك خدمات استشارية احترافية وحلول منتجات عالية الجودة.',
  
  contact_address_title: 'عنوان الشركة',
  contact_address_value: 'غرفة 2021، رقم 1 Hung To Road، Kwun Tong، هونغ كونغ',
  contact_address_value_en: '香港觀塘區鴻圖道1號2021室',
  
  contact_phone_title: 'الهاتف',
  contact_phone_value: '+852 6468 5009',
  
  contact_email_title: 'البريد الإلكتروني',
  contact_email_value: 'dragonlee03@163.com',
  
  contact_coverage_title: 'التغطية التجارية',
  contact_coverage_value: 'أوروبا · دبي · أمريكا اللاتينية · جنوب شرق آسيا',
  
  contact_hours_title: 'ساعات العمل',
  contact_hours_value: 'الاثنين - الجمعة 9:00 - 18:00',
  
  contact_form_name: 'الاسم',
  contact_form_name_placeholder: 'الرجاء إدخال اسمك',
  contact_form_email: 'البريد الإلكتروني',
  contact_form_email_placeholder: 'الرجاء إدخال بريدك الإلكتروني',
  contact_form_phone: 'الهاتف',
  contact_form_phone_placeholder: 'الرجاء إدخال رقم هاتفك',
  contact_form_company: 'اسم الشركة',
  contact_form_company_placeholder: 'الرجاء إدخال اسم شركتك',
  contact_form_message: 'الرسالة',
  contact_form_message_placeholder: 'الرجاء إدخال رسالتك',
  contact_form_submit: 'إرسال',
  contact_form_submitting: 'جاري الإرسال...',
  contact_form_success: 'تم الإرسال بنجاح! سنتصل بك قريبًا.',
  contact_form_error: 'فشل الإرسال، يرجى المحاولة مرة أخرى لاحقًا.',
  contact_form_char_limit: '/500',
  
  // التذييل
  footer_company_name: 'Hong Kong BOJM Trading Co., Ltd.',
  footer_company_name_en: '香港博鑫貿易有限公司',
  footer_company_desc: 'متخصصون في التجارة العالمية لهواتف Apple الذكية، نقدم منتجات عالية الجودة وخدمات احترافية للعملاء.',
  
  footer_quick_links: 'روابط سريعة',
  footer_link_about: 'عن الشركة',
  footer_link_business: 'أعمالنا',
  footer_link_team: 'فريقنا',
  footer_link_achievements: 'الإنجازات',
  footer_link_contact: 'اتصل بنا',
  
  footer_products_title: 'المنتجات',
  footer_product_new: 'هواتف Apple الجديدة',
  footer_product_resource: 'هواتف Apple المجددة',
  footer_product_used: 'هواتف Apple المستعملة',
  
  footer_regions_title: 'مناطق التغطية',
  footer_region_europe: 'أوروبا',
  footer_region_dubai: 'دبي',
  footer_region_latam: 'أمريكا اللاتينية',
  footer_region_sea: 'جنوب شرق آسيا',
  
  footer_copyright: '© 2024 Hong Kong BOJM Trading Co., Ltd. 香港博鑫貿易有限公司 جميع الحقوق محفوظة',
  footer_powered: 'Powered by Readdy',
};

export default ar;
